module.exports = __webpack_public_path__ + "img/25.1d612caa.jpg";